import { Change, OpenAPI } from './Change'

export class UpdateContactName extends Change {
  constructor(readonly value: string) {
    super()
  }
  apply(document: OpenAPI): void {
    document.info.contact ??= {}
    document.info.contact.name = this.value
  }
}

export class UpdateContactURL extends Change {
  constructor(readonly value: string) {
    super()
  }
  apply(document: OpenAPI): void {
    document.info.contact ??= {}
    document.info.contact.url = this.value
  }
}

export class UpdateContactEmail extends Change {
  constructor(readonly value: string) {
    super()
  }
  apply(document: OpenAPI): void {
    document.info.contact ??= {}
    document.info.contact.email = this.value
  }
}
